import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  toggle(event) {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = event.target.checked
    })
  }

  submitExport(event) {
    event.preventDefault()
    const form = this.element.querySelector('#sage-export-form')

    form.querySelectorAll('input[name="ids[]"]').forEach(input => input.remove())

    let selectedIds = this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.dataset.value)

    if (selectedIds.length === 0) {
      selectedIds = this.checkboxTargets.map(checkbox => checkbox.dataset.value)
    }

    selectedIds.forEach(id => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'ids[]'
      input.value = id
      form.appendChild(input)
    })

    form.submit()
  }
}
